export const T = {
  en_GB: {
    textMode: "Text Input",
    fileMode: "File Upload",
    uploadCsv: "Upload CSV",
    toggleMode: "Toggle input mode",
  },
  nb_NO: {
    textMode: "Tekst",
    fileMode: "Filopplasting",
    uploadCsv: "Last opp CSV",
    toggleMode: "Bytt inndatamodus",
  },
} as const;
